import { KYMW4002Component } from './kymw4002.component';

/**
 * プロモーションマスタメンテナンス画面の値を管理するクラス
 *
 * @export KYMW4002Model
 * @class KYMW4002Model
 */
export class KYMW4002Model {

  kymw4002Component: KYMW4002Component;

  public mode = Number(0);                                              // 起動モード(0：登録、1：更新)

  // 画面バインド用変数
  public promotionNo: string = <string>'';                                      // プロモーション番号
  public promotionInfo: string = <string>'';                                    // プロモーション情報
  public markCode1: string = <string>'';                                        // マークコード１
  public markCode2: string = <string>'';                                        // マークコード２
  public markCode3: string = <string>'';                                        // マークコード３
  public markCode4: string = <string>'';                                        // マークコード４
  public markCode5: string = <string>'';                                        // マークコード５
  public multiPublishFlag: boolean = <boolean>false;                            // Ｗ掲載フラグ(0：多重掲載なし、1：多重掲載あり)

}
